"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjustmentRule = exports.DiscountOperator = exports.DiscountRuleType = exports.AdjustmentType = exports.AdjustmentUnit = void 0;
var AdjustmentUnit;
(function (AdjustmentUnit) {
    AdjustmentUnit["PERCENTAGE"] = "PERCENTAGE";
    AdjustmentUnit["FLAT"] = "FLAT";
})(AdjustmentUnit = exports.AdjustmentUnit || (exports.AdjustmentUnit = {}));
var AdjustmentType;
(function (AdjustmentType) {
    AdjustmentType["DISCOUNT"] = "DISCOUNT";
    AdjustmentType["SURCHARGE"] = "SURCHARGE";
    AdjustmentType["REWARD"] = "REWARD";
})(AdjustmentType = exports.AdjustmentType || (exports.AdjustmentType = {}));
var DiscountRuleType;
(function (DiscountRuleType) {
    DiscountRuleType["PRODUCT_CATEGORY_RULE"] = "PRODUCT_CATEGORY_RULE";
    DiscountRuleType["PRODUCT_CATEGORY_QTY_RULE"] = "PRODUCT_CATEGORY_QTY_RULE";
    DiscountRuleType["PRODUCT_CATEGORY_BUY_SOME_GET_SOME_RULE"] = "PRODUCT_CATEGORY_BUY_SOME_GET_SOME_RULE";
})(DiscountRuleType = exports.DiscountRuleType || (exports.DiscountRuleType = {}));
var DiscountOperator;
(function (DiscountOperator) {
    DiscountOperator["EXACTLY"] = "EXACTLY";
    DiscountOperator["MORE_THAN"] = "MORE_THAN";
})(DiscountOperator = exports.DiscountOperator || (exports.DiscountOperator = {}));
var AdjustmentRule;
(function (AdjustmentRule) {
    AdjustmentRule["GUEST_COUNT"] = "GUEST_COUNT";
})(AdjustmentRule = exports.AdjustmentRule || (exports.AdjustmentRule = {}));
//# sourceMappingURL=adjustments.js.map